import apiClient from '../connections/api'

const createNews = (newsData) => {
    return apiClient.post('/news', newsData)
}

const uploadFile = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post('/news/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

const getMyNews = (userId) => {
    return apiClient.post('/news/by-user', { userId })
}

const getAllNews = () => {
    return apiClient.get('/news')
}

const markAsRead = (id, userId) => {
    return apiClient.patch(`/news/${id}/read`, { userId })
}

const markAllAsRead = (userId) => {
    return apiClient.patch('/news/read-all', { userId })
}

const deleteNews = (id) => {
    return apiClient.delete(`/news/${id}`)
}

const restoreNews = (id) => {
    return apiClient.patch(`/news/${id}/restore`)
}

const updateNews = (id, newsData) => {
    return apiClient.patch(`/news/${id}`, newsData)
}

const getArchiveConfig = () => {
    return apiClient.get('/news/archive-config')
}

const updateArchiveConfig = (config) => {
    return apiClient.patch('/news/archive-config', config)
}

export default {
    createNews,
    uploadFile,
    getMyNews,
    getAllNews,
    markAsRead,
    markAllAsRead,
    deleteNews,
    restoreNews,
    updateNews,
    getArchiveConfig,
    updateArchiveConfig
}
